/* Theme-owned labels and variant context. App pricing and cart actions remain owned by the app. */
(() => {
  const main = document.getElementById('MainContent');
  if (!main) return;
  const labels = JSON.parse(document.getElementById('StudioConversionLabels')?.textContent || '{}');
  const products = new Map();
  document.querySelectorAll('[data-studio-listing-data]').forEach(script => {
    try { for (const [id, data] of Object.entries(JSON.parse(script.textContent))) products.set(id, data); } catch {}
  });
  const search = document.querySelector('[data-studio-search-fallback]');
  if (search) main.classList.add('studio-search-page');
  function enhance(card) {
    let product;
    try { product = JSON.parse(card.getAttribute('data-product') || '{}'); } catch { return; }
    const min = Number(product.priceMin), max = Number(product.priceMax);
    // Split products and selected variants already have an explicit price context.
    const varies = !product.variantId && max > min;
    const price = card.querySelector('.boost-sd__product-price--default');
    if (!price) return;
    let from = price.querySelector('[data-studio-from]');
    if (varies && !from) {from = document.createElement('span');from.dataset.studioFrom = '';from.textContent = `${labels.from} `;price.prepend(from);}
    if (!varies) from?.remove();
    for (const accessible of card.querySelectorAll('.boost-sd__product-price .boost-sd__visually-hidden')) {
      const translated = accessible.textContent.replace(/Regular price/g,labels.regular).replace(/Sale price/g,labels.sale).replace(/Unit price/g,labels.unit);
      if (accessible.textContent !== translated) accessible.textContent = translated;
    }
    const data = products.get(card.dataset.productId || card.id);
    if (data) {
      const facts = Array.isArray(data.facts) ? data.facts.slice(0,3) : [data.summary].filter(Boolean);
      let list = card.querySelector('.studio-card-facts');
      if (facts.length && !list) { list = document.createElement('ul'); list.className = 'studio-card-facts';card.querySelector('.boost-sd__product-price')?.after(list); }
      if (list && list.dataset.facts !== JSON.stringify(facts)) {
        list.replaceChildren(...facts.map(text => {const li=document.createElement('li');li.textContent=text;return li;}));list.dataset.facts=JSON.stringify(facts);
      }
    }
    if (!data || product.variantId || !Number.isFinite(min) || Math.abs(Number(data.price)-min) > 0.005) {
      card.querySelector('.studio-listing-variant')?.remove();
      for (const link of card.querySelectorAll('[data-studio-variant-link]')) {
        delete link.dataset.studioVariantLink;
        delete link.dataset.studioVariantUrl;
      }
      return;
    }
    let context = card.querySelector('.studio-listing-variant');
    if (!context) {context = document.createElement('div');context.className = 'studio-listing-variant';card.querySelector('.boost-sd__product-price')?.after(context);}
    const content = [data.title, data.unit].filter(Boolean).join(' · ');
    if (context.textContent !== content) context.textContent = content;
    // Price, package and destination all refer to this exact price-matching variant.
    for (const link of card.querySelectorAll('a.boost-sd__product-link')) {
      const url = new URL(link.href, location.origin);
      if (url.searchParams.has('variant') && url.searchParams.get('variant') !== String(data.variant)) {
        delete link.dataset.studioVariantLink;
        delete link.dataset.studioVariantUrl;
        continue;
      }
      url.searchParams.set('variant',data.variant);
      if (link.href !== url.href) link.href = url.href;
      link.dataset.studioVariantLink = 'true';
      link.dataset.studioVariantUrl = url.href;
    }
  }
  let pending = false;
  function refresh() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      const resultSource = main.querySelector('facets-form-component[data-results-count][data-page-type="collection"]');
      const resultCount = resultSource?.dataset.resultsCount;
      if (resultCount !== undefined && /^\d+$/.test(resultCount)) {
        for (const counter of main.querySelectorAll('[data-studio-collection-count]')) {
          if (counter.textContent !== resultCount) counter.textContent = resultCount;
        }
      }
      main.querySelectorAll('.boost-sd__product-item[data-product]').forEach(enhance);
      if (search) {
        const root = main.querySelector('.boost-sd-container-search-page');
        const cards = root?.querySelector('.boost-sd__product-item');
        const empty = root?.querySelector('.boost-sd__no-search-result-page');
        main.toggleAttribute('data-studio-boost-ready',!!(cards || empty));
        main.toggleAttribute('data-studio-search-empty',!!empty);
        const message = main.querySelector('[data-studio-search-message]');
        if (empty && message && message.textContent !== labels.no_results) message.textContent = labels.no_results;
      }
    });
  }
  const scope = '.boost-sd-container-search-page, .boost-sd-container, .boost-sd__product-item, facets-form-component[data-results-count]';
  // Boost's card handler can navigate using its cached default-variant URL.
  // Use the verified price-matching destination for a regular link activation.
  window.addEventListener('click',event => {
    const link = event.target instanceof Element && event.target.closest('a[data-studio-variant-link]');
    if (!link || !main.contains(link) || event.button !== 0) return;
    link.href = link.dataset.studioVariantUrl;
    event.stopImmediatePropagation();
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    location.assign(link.dataset.studioVariantUrl);
  },true);
  const observer = new MutationObserver(records => {
    if (records.some(r => r.target instanceof Element && (r.target.closest(scope) || [...r.addedNodes].some(n => n instanceof Element && (n.matches(scope) || n.querySelector(scope)))))) refresh();
  });
  const observe = () => observer.observe(main,{childList:true,subtree:true,attributes:true,attributeFilter:['data-product','data-results-count']});
  observe();
  window.addEventListener('pagehide',() => observer.disconnect());
  window.addEventListener('pageshow',event => { if (event.persisted) {observe();refresh();} });
  refresh();
})();
